import * as popUpStyles from '../../styles/layout/search-pop-up.module.scss';
import PropTypes from 'prop-types';

import IconContainer from './IconContainer';
import React from 'react';
import {useTranslation} from 'react-i18next';

const InfinitePagination = React.memo(function Pagination ({
  onclick, pageIndex, prevItems, label, setFocus
}) {

  const {t} = useTranslation();

  return (
    <button
      aria-label={t('search.pagination.button.see_all')}
      className={popUpStyles.toutVoirButtonPage}
      onClick={() => {
        if (onclick) {
          onclick(pageIndex + 1, prevItems);
          if (setFocus) {
            setFocus();
          }
        }
      }}
      onKeyDown={() => {
        if (onclick) {
          onclick(pageIndex + 1, prevItems);
          if (setFocus) {
            setFocus();
          }
        }
      }}
      tabIndex="0"
    >
      <div style={{marginRight: 5, color: 'inherit'}}>
        <IconContainer
          color="WHITE"
          icon="PLUS_SQUARE"
          noHover
          size={30}
        >
        </IconContainer>
      </div>
      <p
        className={popUpStyles.more}
      >
        {label}
      </p>
    </button>
  );
});

InfinitePagination.propTypes = {
  label: PropTypes.string.isRequired,
  onclick: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired,
  prevItems: PropTypes.array.isRequired,
  setFocus: PropTypes.func,
};

export default InfinitePagination;
